function ProfileMedia({ enquiry }) {
  return <div className="page">Coming Soon</div>;
}

export default ProfileMedia;
